export const withClientContactRequirement = (schema, requirement, message = "Email or Phone is required") =>
  schema.test("email-or-phone", message, function (values) {
    const required = typeof requirement === "function" ? requirement(values) : requirement;
    if (!required || values?.email?.trim() || values?.phone_number?.trim()) return true;
    return this.createError({ path: "contact_info", message });
  });
